import { defineComponent as _defineComponent } from 'vue'
import VChart from './VChart.vue';
import take from 'lodash/take';
import { makeBarChartOptions, makeThemedChartDataset, useReportsState } from 'ah-reports';
import { linesColorPrimary } from '../helpers/graphColors';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, reactive, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopAccountsCountReportChart',
  props: {
    fromDate: null,
    toDate: null,
    partnerId: null
  },
  setup(__props: any) {

const props = __props as {
  fromDate: Date;
  toDate: Date;
  /**
   * Whether to limit results to a particular Partner
   * - Value should only be used in Admin usage (non-admin usage only has access to a single Partner)
   * - Value only used if `partnerAccounts` is false
   */
  partnerId?: string;
};

const TOP_DISPLAY_AMOUNT = 5;

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: onRetryFromParentManager,
});

function onRetryFromParentManager(k: string) {
  if (k === 'loadData') {
    loadDates();
  }
}



const state = reactive({
  options: makeBarChartOptions(
    { horizontal: true, gridColor: linesColorPrimary },
    {
      scales: {
        y: {
          ticks: {
            autoSkip: false,
          },
        },
      },
    }
  ),
  data: makeThemedChartDataset({
    labels: [],
    colorNames: ['widgets-green'],
  }),
});

const dates = computed(() => ({
  from: props.fromDate,
  to: props.toDate,
}));

const reportsState = useReportsState();

function loadDates() {
  requestManager.manager
    .cancelAndNew(
      'loadData',
      reportsState.services.trade.getClientTopAccountsReport(props.fromDate, props.toDate, props.partnerId)
    )
    .subscribe((response) => {
      const accounts = take(response.list, TOP_DISPLAY_AMOUNT);
      state.data.datasets![0].data! = accounts.map((i) => i.tradedAmount);
      state.data.labels = accounts.map((i) => i.clientName);

      // Force update by replacing prop reference entirely
      state.options = { ...state.options };
      state.data = { ...state.data };
    });
}

watch(dates, loadDates, { immediate: true });

return { __sfc: true,TOP_DISPLAY_AMOUNT, requestManager, onRetryFromParentManager, props, state, dates, reportsState, loadDates, VChart }
}

})